module.exports = __webpack_public_path__ + "static/media/statement.57156488.svg";